export const defaultSchema = {
  credential_name: {
    id: 'credential_name',
    label: 'Credential Name',
    placeholder: 'Add Credential Name (for your own usage)',
    isSecure: false,
  },
  client_id: {
    id: 'client_id',
    label: 'Client ID',
    placeholder: 'Enter Client ID',
    isSecure: true,
  },
  partner_id: {
    id: 'partner_id',
    label: 'Partner ID',
    placeholder: 'Enter Partner ID',
    isSecure: true,
  },
  client_secret: {
    id: 'client_secret',
    label: 'Secret Key',
    placeholder: 'Enter Secret Key',
    isSecure: true,
  },
  device_search_subdomain: {
    id: 'device_search_subdomain',
    label: 'Agency Domain for Evidence.com',
    placeholder: 'Enter Agency Domain',
    isSecure: false,
    url: 'evidence.com',
  },
};

export const partnerSchema = [
  {
    name: 'Axon',
    description: {
      title: 'Officer Locations',
      content:
        'Portal may display the real-time or near-real time locations of first responders wearing Axon Body 3 cameras on the RapidSOS Portal map.',
    },
    support_url:
      'https://my.axon.com/s/article/Respond-RapidSOS-Integration?language=en_US',
  },
];

export const mockUserCredentials = [
  {
    credential_name: 'jack',
    source: 'SlowSOS',
    timestamp: '123456412341234',
    client_id: 'SlowSOS',
    partner_id: 'SlowSOS',
    secret_key: 'SlowSOS',
    agency_domain: 'SlowSOS',
    valid: true,
  },
  {
    credential_name: 'joseph',
    source: 'Axon',
    timestamp: '12341234',
    client_id: 'Axon',
    partner_id: 'Axon',
    secret_key: 'Axon',
    agency_domain: 'Axon',
    valid: true,
  },
  {
    credential_name: 'perry',
    source: 'CallerID',
    timestamp: '1234',
    client_id: 'CallerID',
    partner_id: 'CallerID',
    secret_key: 'CallerID',
    agency_domain: 'CallerID',
    valid: true,
  },
  {
    credential_name: 'anastasiaanasta',
    source: 'EagleEye',
    timestamp: '1',
    client_id: 'EagleEye',
    partner_id: 'EagleEye',
    secret_key: 'EagleEye',
    agency_domain: 'EagleEye',
    valid: true,
  },
  {
    credential_name: 'vinson',
    source: 'EventGuard',
    timestamp: '12341234',
    client_id: 'EventGuard',
    partner_id: 'EventGuard',
    secret_key: 'EventGuard',
    agency_domain: 'EventGuard',
    valid: false,
  },
  {
    credential_name: 'eddie',
    source: 'Axon',
    timestamp: '',
    client_id: 'Axon',
    partner_id: 'Axon',
    secret_key: 'Axon',
    agency_domain: 'Axon',
    valid: true,
  },
  {
    credential_name: 'jeremy',
    source: 'Defense+',
    timestamp: '12gfdgh1234',
    client_id: 'Defense+',
    partner_id: 'Defense+',
    secret_key: 'Defense+',
    agency_domain: 'Defense+',
    valid: true,
  },
  {
    credential_name: 'jack',
    source: 'SlowSOS',
    timestamp: '123412341234',
    client_id: 'SlowSOS',
    partner_id: 'SlowSOS',
    secret_key: 'SlowSOS',
    agency_domain: 'SlowSOS',
    valid: true,
  },
  {
    credential_name: 'joseph',
    source: 'Axon',
    timestamp: '12asdf1234',
    client_id: 'Axon',
    partner_id: 'Axon',
    secret_key: 'Axon',
    agency_domain: 'Axon',
    valid: true,
  },
  {
    credential_name: 'perry',
    source: 'CallerID',
    timestamp: '123d4',
    client_id: 'CallerID',
    partner_id: 'CallerID',
    secret_key: 'CallerID',
    agency_domain: 'CallerID',
    valid: true,
  },
  {
    credential_name: 'anastasia',
    source: 'EagleEye',
    timestamp: '1dfh',
    client_id: 'EagleEye',
    partner_id: 'EagleEye',
    secret_key: 'EagleEye',
    agency_domain: 'EagleEye',
    valid: true,
  },
  {
    credential_name: 'vinson',
    source: 'EventGuard',
    timestamp: '123412341',
    client_id: 'EventGuard',
    partner_id: 'EventGuard',
    secret_key: 'EventGuard',
    agency_domain: 'EventGuard',
    valid: true,
  },
  {
    credential_name: 'eddie',
    source: 'Axon',
    timestamp: 'asf23',
    client_id: 'Axon',
    partner_id: 'Axon',
    secret_key: 'Axon',
    agency_domain: 'Axon',
    valid: true,
  },
  {
    credential_name: 'jeremy',
    source: 'Defense+',
    timestamp: '123a234',
    client_id: 'Defense+',
    partner_id: 'Defense+',
    secret_key: 'Defense+',
    agency_domain: 'Defense+',
    valid: true,
  },
];
